import Box from '@mui/material/Box';
import { SxProps } from '@mui/material/styles';

type LogoProps = {
  sx?: SxProps;
};

const Logo = ({ sx }: LogoProps) => (
  <Box sx={sx}>
    <svg viewBox="0 0 161 154" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7598 87.0235C21.9598 91.7413 24.9628 95.8284 28.5302 99.1979L2.82905 111.183C1.90161 111.615 0.96072 111.984 0.0114095 112.29C-0.131428 118.256 1.06407 124.346 3.75724 130.122C13.0935 150.143 36.8927 158.806 56.9143 149.469L121.484 119.36C141.505 110.024 150.168 86.2247 140.831 66.2031C138.631 61.4853 135.628 57.3982 132.061 54.0287L157.762 42.0441C158.69 41.6116 159.63 41.243 160.58 40.9366C160.723 34.9702 159.527 28.8804 156.834 23.1048C147.498 3.08322 123.698 -5.57899 103.677 3.75723L39.1074 33.8665C19.0858 43.2027 10.4236 67.0019 19.7598 87.0235ZM79 97C90.0457 97 99 88.0457 99 77C99 65.9543 90.0457 57 79 57C67.9543 57 59 65.9543 59 77C59 88.0457 67.9543 97 79 97Z"
        fill="#078DEE"
      />
    </svg>
  </Box>
);

export default Logo;
